import type { IMap } from '@pn/core/services/map/ports';
import { emptyMap } from './emptyMap';
import { addAnnotationLayer } from './methods/addAnnotationLayer';
import { addDataLayer } from './methods/addDataLayer';
import { addQueryAreaOutline } from './methods/addQueryAreaOutline';
import { disableMovement } from './methods/disableMovement';
import { enableMovement } from './methods/enableMovement';
import { filterLayer } from './methods/filterLayer';
import { fitToBBox } from './methods/fitToBBox';
import { getCenter } from './methods/getCenter';
import { getScreenshot } from './methods/getScreenshot';
import { getViewportBounds } from './methods/getViewportBounds';
import { hasLayer } from './methods/hasLayer';
import { hideLayer } from './methods/hideLayer';
import { initialize } from './methods/initialize';
import { moveDataLayer } from './methods/moveDataLayer';
import { moveLayer } from './methods/moveLayer';
import { moveTo } from './methods/moveTo';
import { removeAnnotationLayer } from './methods/removeAnnotationLayer';
import { removeDataLayer } from './methods/removeDataLayer';
import { removeQueryAreaOutline } from './methods/removeQueryAreaOutline';
import { resize } from './methods/resize';
import { setFeatureState } from './methods/setFeatureState';
import { setZoom } from './methods/setZoom';
import { showLayer } from './methods/showLayer';
import { unsetFeatureState } from './methods/unsetFeatureState';
import { updateDataLayerStyle } from './methods/updateDataLayerStyle';
import { updateLayerData } from './methods/updateLayerData';
import { updateMode } from './methods/updateMode';

export type MapboxIMap = IMap<mapboxgl.Map>;

/**
 * Mapbox implementation of PN Maps core interface.
 *
 * Place every method into a separate file in the ./methods directory.
 * Every property should define its default uninitialized value.
 */
export const mapboxPnMap: MapboxIMap = {
  _native: emptyMap,

  initialize,

  filters: {},

  getCenter,
  getViewportBounds,

  hasLayer,

  showLayer,
  hideLayer,
  moveLayer,
  filterLayer,

  setFeatureState,
  unsetFeatureState,

  addDataLayer,
  addAnnotationLayer,
  updateLayerData,
  updateDataLayerStyle,
  moveDataLayer,
  removeDataLayer,
  removeAnnotationLayer,

  addQueryAreaOutline,
  removeQueryAreaOutline,

  updateMode,

  moveTo,
  fitToBBox,
  setZoom,
  resize,
  disableMovement,
  enableMovement,

  getScreenshot,
};
